import { render, staticRenderFns } from "./activity-changes.vue?vue&type=template&id=54073b1e&scoped=true&"
import script from "./activity-changes.ts?vue&type=script&lang=ts&"
export * from "./activity-changes.ts?vue&type=script&lang=ts&"
import style0 from "./activity-changes.scss?vue&type=style&index=0&id=54073b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54073b1e",
  null
  
)

export default component.exports